import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[adsptAccordionExpandedContent]' })
export class AccordionExpandedContentDirective {
  constructor(readonly tr: TemplateRef<any>) {}
}
